import React, { useState, useEffect } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Box, Typography, TextField, Chip, Divider, Stack,
} from "@mui/material";
import { CANVAS_PRESETS } from "./constants";

export default function CanvasSizeDialog({ open, currentSize, onClose, onApply }) {
    const [custom, setCustom] = useState({ width: currentSize.width, height: currentSize.height });

    // Sync with currentSize when dialog opens
    useEffect(() => {
        if (open) setCustom({ width: currentSize.width, height: currentSize.height });
    }, [open, currentSize]);

    const isPresetActive = (p) => custom.width === p.width && custom.height === p.height;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Dimensions du canvas</DialogTitle>
            <DialogContent>
                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Formats prédéfinis
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
                    {CANVAS_PRESETS.map(p => (
                        <Chip
                            key={p.label}
                            label={`${p.label} (${p.width}×${p.height})`}
                            onClick={() => setCustom({ width: p.width, height: p.height })}
                            color={isPresetActive(p) ? "primary" : "default"}
                            variant={isPresetActive(p) ? "filled" : "outlined"}
                            size="small"
                        />
                    ))}
                </Box>

                <Divider sx={{ mb: 2 }} />

                <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1.5 }}>
                    Dimensions manuelles (px)
                </Typography>
                <Stack direction="row" spacing={2} alignItems="center">
                    <TextField
                        label="Largeur" type="number" size="small"
                        value={custom.width}
                        inputProps={{ min: 100, max: 8000 }}
                        onChange={e => setCustom(s => ({ ...s, width: Math.max(100, Number(e.target.value)) }))}
                        sx={{ width: 140 }}
                    />
                    <Typography variant="body1" color="text.secondary">×</Typography>
                    <TextField
                        label="Hauteur" type="number" size="small"
                        value={custom.height}
                        inputProps={{ min: 100, max: 8000 }}
                        onChange={e => setCustom(s => ({ ...s, height: Math.max(100, Number(e.target.value)) }))}
                        sx={{ width: 140 }}
                    />
                    <Typography variant="caption" color="text.secondary">px</Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button variant="contained" onClick={() => onApply(custom)}>Appliquer</Button>
            </DialogActions>
        </Dialog>
    );
}
